import {ProductDetailCreateDto, ProductDetailUpdateDto} from "../../../api";
import {CrudFormItemProps, CrudFormModal, nameof} from "digimuth-components/dist";
import TextArea from "antd/es/input/TextArea";

const formItems: CrudFormItemProps[] = [
    {
        name: nameof<ProductDetailCreateDto>("header"),
        rules: [
            {required: true, message: 'To pole jest wymagane'}
        ],
        label: "Nagłówek"
    },
    {
        name: nameof<ProductDetailCreateDto>("content"),
        rules: [
            {required: true, message: 'To pole jest wymagane'}
        ],
        label: "Tekst",
        children: <TextArea autoSize={{minRows: 3}}/>
    },
];

export default function ProductDetailModalForm(props: ProductDetailModalProps) {

    return <CrudFormModal
        forceRender={true}
        destroyOnClose={true}
        shouldClearModalOnClose={true}
        formItems={formItems}
        onSubmit={props.onSubmit}
        onModalCancelClicked={() => props.setModalVisibility(false)}
        initialValues={props.initialValues}
        modalOkText={props.saveButtonTitle}
        modalCancelText={props.cancelButtonTitle}
        modalTitle={props.modalTitle}
        isModalVisible={props.isModalVisible}
    />;
}

interface ProductDetailModalProps {
    initialValues?: ProductDetailCreateDto | ProductDetailUpdateDto,
    isModalVisible: boolean;
    setModalVisibility: (isVisible: boolean) => any;
    onSubmit: (value: ProductDetailCreateDto | ProductDetailUpdateDto) => Promise<any>,
    modalTitle: string,
    saveButtonTitle: string,
    cancelButtonTitle: string;
}
